import withMetadataArgument from '../min/exports/withMetadataArgument.js'

import _parse from '../es6/legacy/parse.js'

export function parse() {
	return withMetadataArgument(_parse, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/parse.js
// module id = 1146
// module chunks = 22